
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["edit-additional__item-icon--sticks",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"84","height":"77","viewBox":"0 0 84 77"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h84v77H0z"}})])]),_c('g',{attrs:{"data-name":"Group 1","fill":"#55534f","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 959","d":"M0 66.901l29.67-26.96L75.305 0l1.685 1.854-44.713 41.7-29.3 26.624z"}}),_c('path',{attrs:{"data-name":"Path 960","d":"M5.955 73.456l29.67-26.96 45.747-39.82 1.685 1.855-44.825 41.577-29.3 26.623z"}})])])
          )
        }
      }
    